import { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";

const Eligiblity = ({ Show, Hide, Title, subjectUpdateLoader, updateStudySubjectScreen }) => {
  const [check, setCheck] = useState(false);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Check
          onChange={(e) => setCheck(e.target.checked)}
          type="checkbox"
          label="Confirm that all required study visits, assessments, data entries, and applicable follow-up activities have been completed for this subject. Once confirmed, the subject will be marked as completed in the study."
        />
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={!check || subjectUpdateLoader}
          className="updateProfile"
          onClick={updateStudySubjectScreen}
        >
          {subjectUpdateLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Eligibling...
            </div>
          ) : (
            "Mark Eligible"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default Eligiblity;
